<script lang="ts" setup>
  import FlowLogo from '@/shared/components/rebranding/FlowLogo/FlowLogo.vue'
  import { useHomeUrl } from '@/shared/composables/useHomeUrl'
  import { useGoogleAnalytics } from '@/shared/composables/useGoogleAnalytics/useGoogleAnalytics'
  import { STATE_LIST_INS_KEY } from '@/shared/constants/other.constants'
  import { useRouter } from 'vue-router'
  import { PurchaseFlowRoutes } from '@/shared/types/router.types'
  import { IconQC } from '@qicgroupdoha/qic-connect-ds'
  import { inject } from 'vue'

  interface Props {
    withArrowBack?: boolean
  }

  interface Emits {
    (e: 'back'): void
  }

  withDefaults(defineProps<Props>(), {
    withArrowBack: true,
  })

  const emit = defineEmits<Emits>()
  const router = useRouter()
  const gaService = useGoogleAnalytics()
  const homeUrl = useHomeUrl()

  const sendGAEvent = () => {
    const page =
      localStorage.getItem(STATE_LIST_INS_KEY) || (router.currentRoute.value.name as string)
    const params =
      page === PurchaseFlowRoutes.INSURANCE_RESULT
        ? {
            policy_id: localStorage.getItem('user-payload.policyno') || '',
          }
        : {}
    gaService.sendToMainPage(page, params)
  }

  const localeRTL = inject<boolean>('localeRTL')
</script>

<template>
  <div class="header-flow">
    <!-- @vue-ignore -->
    <IconQC
      v-if="withArrowBack"
      :name="localeRTL ? 'arrow-narrow-right' : 'arrow-narrow-left'"
      size="lg"
      :color="$qicConnect.colors.icn.srf.tertiary"
      class="header-flow__arrow"
      data-test="back-button"
      @click="emit('back')"
    />
    <FlowLogo :href="homeUrl" @click="sendGAEvent" />
  </div>
</template>

<style lang="scss">
  @use './FlowHeader.scss';
</style>
